import { Box, BoxProps, styled } from '@mui/material';

import { collapsedGanttGroupHeight, groupNameWidth } from './GanttGroup.style';

export const transitionDuration = '300ms';
export const transitionEasing = 'cubic-bezier(0.4, 0, 0.2, 1) 0ms';
export const StyledCountBox = styled(Box)<
    {
        index: number;
    } & Partial<BoxProps>
>`
    color: rgba(255, 255, 255, 0.7);
    position: sticky;
    top: 0;
    width: 100vw;
    height: ${collapsedGanttGroupHeight}px;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    // counteract own height
    margin-bottom: -${collapsedGanttGroupHeight}px;
    pointer-events: none;
    user-select: none;
    transition: opacity ${transitionDuration} ${transitionEasing};
`;
export const StyledCollapseChildren = styled(Box)<
    {
        open: boolean;
        groupheight: number;
    } & Partial<BoxProps>
>`
    overflow-x: hidden;
    transition: opacity ${transitionDuration}, height ${transitionDuration} ${transitionEasing};
    height: ${({ open, groupheight }) => (open ? groupheight : collapsedGanttGroupHeight)}px;
    opacity: ${({ open }) => (open ? 1 : 0)};
    ${({ open }) => (!open ? '& * { pointer-events: none; }' : '')}
`;
export const GanttGroupNameBar = styled(Box)<
    {
        open: boolean;
        groupheight: number;
        index: number;
        resource: string;
    } & Partial<BoxProps>
>`
    user-select: none;
    position: sticky;
    z-index: 10;
    cursor: pointer;
    width: 60px;
    // @workaround : "height: 100%" don't work with sticky. "100%" returns the height of the GanttGroupNameBar, not the height of the parent GanttGroup.
    // We must compute the height of the group, by multiplying the number of flights by the row height.
    height: ${({ open, groupheight }) => (open ? groupheight : collapsedGanttGroupHeight)}px;
    min-height: ${collapsedGanttGroupHeight}px;
    // stick to the bottom of the GanttGroup
    bottom: 0;
    // counteract component's own width
    left: -${groupNameWidth}px;
    // counteract component's own height
    margin-bottom: -${({ open, groupheight }) => (open ? groupheight : collapsedGanttGroupHeight)}px;
    // counteract Gantt padding-left
    margin-left: -${groupNameWidth}px;
    color: white;
    font-size: 13px;
    font-family: Roboto, serif;
    display: flex;
    justify-content: center;
    align-items: center;

    ${({ resource, index, theme }) =>
        resource === 'true'
            ? { background: index % 2 === 0 ? theme.palette.blue.darkest : theme.palette.primary.main }
            : {
                  background: index % 2 === 0 ? theme.palette.blue.darkest : theme.palette.primary.main,
                  backgroundImage:
                      'repeating-linear-gradient(-45deg,rgba(0, 0, 0, 0),rgba(0, 0, 0, 0) 4px,rgba(219, 67, 67, 0.6) 3px,rgba(219, 67, 67, 0.6) 6px)',
                  backgroundSize: '8px 8px',
                  backgroundPosition: 'top left',
              }};
`;
export const StyledBox = styled(Box)`
    pointer-events: all;
    min-height: 50px;

    &.firstOrLast {
        border-bottom: 2px solid #082940;
    }
`;
